module.exports = __webpack_public_path__ + "Flag-184.1888498f669589d312bca77da4eb3713.svg";